import React from 'react';

interface AreaLinkProps {
    areaId: number;
    areaName: string;
    onClick?: (areaId: number) => void;
    style?: React.CSSProperties;
}

/**
 * Reusable component for rendering area names as clickable links
 * Used across all report sections for consistent navigation
 */
export const AreaLink: React.FC<AreaLinkProps> = ({ areaId, areaName, onClick, style }) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        if (onClick) {
            onClick(areaId);
        }
    };

    return (
        <a
            href="#"
            onClick={handleClick}
            style={{
                color: '#1890ff',
                textDecoration: 'none',
                cursor: 'pointer',
                ...style,
            }}
            onMouseEnter={(e) => {
                e.currentTarget.style.textDecoration = 'underline';
            }}
            onMouseLeave={(e) => {
                e.currentTarget.style.textDecoration = 'none';
            }}
            title={`View report for ${areaName}`}
        >
            {areaName}
        </a>
    );
};

export default AreaLink;
